var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessengerFbNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#messenger-fb-new_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .002A7.847 7.847 0 00.001 7.667a7.521 7.521 0 002.667 5.707v2.293a.333.333 0 00.51.282l1.857-1.16A8.255 8.255 0 008 15.333a7.847 7.847 0 008-7.665A7.847 7.847 0 008 .002z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.266 5.468a.333.333 0 00-.427-.094l-3.466 1.89-2.156-1.849a.333.333 0 00-.453.017l-4 4a.333.333 0 00.396.528l3.466-1.89 2.158 1.85c.133.113.33.106.453-.017l4-4a.333.333 0 00.029-.435z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "messenger-fb-new_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/messenger-fb-new.5a82bdb464739a882cc53ec34c9d2afa.svg";
export { SvgMessengerFbNew as ReactComponent };